import { BankReconciliationActionType, CurrencySaleRevaluationType, } from '../bank-reconciliation';
import { CapitalActionTransactionSubType, CapitalActionTypes, } from '../capital-action';
import { FeeActionType } from '../fee-actions';
import { ExpenseType, IncomeOrExpenseTransactionSubType, IncomeType, } from '../income-and-expenses';
import { InvestmentTypes } from '../investment';
import { PartnerTransferTypes } from '../partner-transfer';
import { RealisationTransactionSubType, RealisationTypes, } from '../realisation';
import { RealisedFXGainOrLossType } from '../realised-fx-gain-or-loss';
import { RevaluationTransactionType } from '../revaluation';
import { UnrealisedAssetFXGainOrLossType } from '../unrealised-asset-fx-gain-or-loss';
import { UnrealisedCashFXGainOrLossActionType, UnrealisedCashFXGainOrLossType, } from '../unrealised-cash-fx-gain-or-loss';
import { UnrealisedFXGainOrLossSubType, UnrealisedFXGainOrLossType, } from '../unrealised-fx-gain-or-loss';
export var ActionRef;
(function (ActionRef) {
    ActionRef["Investment"] = "lpInvestment";
    ActionRef["Equalisation"] = "equalisation";
    ActionRef["IncomeOrExpense"] = "incomeOrExpense";
    ActionRef["CapitalAction"] = "capitalAction";
    ActionRef["Realisation"] = "realisation";
    ActionRef["Revaluation"] = "revaluation";
    ActionRef["Reconciliation"] = "reconciliation";
    ActionRef["BankAccountTransfer"] = "bankAccountTransfer";
    ActionRef["Fees"] = "fees";
    ActionRef["PrepaymentResolution"] = "prepaymentResolution";
    ActionRef["UnrealisedFXGainOrLoss"] = "unrealisedFXGainOrLoss";
    ActionRef["RealisedFXGainOrLoss"] = "realisedFXGainOrLoss";
    ActionRef["UnrealisedEquityGainOrLoss"] = "unrealisedEquityGainOrLoss";
    ActionRef["ForeignCurrencySaleGainOrLoss"] = "foreignCurrencySaleGainOrLoss";
    ActionRef["UnrealisedCashFXGainOrLoss"] = "unrealisedCashFXGainOrLoss";
    ActionRef["UnrealisedAssetFXGainOrLoss"] = "unrealisedAssetFXGainOrLoss";
    ActionRef["SaleOfInvestment"] = "saleOfInvestment";
    ActionRef["PartnerTransfer"] = "partnerTransfer";
    ActionRef["ManualAction"] = "manualAction";
})(ActionRef || (ActionRef = {}));
export var ActionCategory;
(function (ActionCategory) {
    ActionCategory["Income"] = "income";
    ActionCategory["Expense"] = "expense";
    ActionCategory["Investment"] = "investment";
    ActionCategory["Realisation"] = "realisation";
    ActionCategory["ManagementFees"] = "managementFees";
    ActionCategory["CapitalActions"] = "capitalActions";
    ActionCategory["FX"] = "fx";
})(ActionCategory || (ActionCategory = {}));
export var ActionOperationType;
(function (ActionOperationType) {
    ActionOperationType[ActionOperationType["Received"] = 0] = "Received";
    ActionOperationType[ActionOperationType["Spent"] = 1] = "Spent";
})(ActionOperationType || (ActionOperationType = {}));
export var ActionStatus;
(function (ActionStatus) {
    ActionStatus["Draft"] = "draft";
    ActionStatus["Approved"] = "approved";
    ActionStatus["Rejected"] = "rejected";
})(ActionStatus || (ActionStatus = {}));
export var ActionTypeDiscriminator;
(function (ActionTypeDiscriminator) {
    ActionTypeDiscriminator["PreDefinedActionType"] = "preDefinedActionType";
    ActionTypeDiscriminator["CustomActionType"] = "customActionType";
})(ActionTypeDiscriminator || (ActionTypeDiscriminator = {}));
export var CustomActionType;
(function (CustomActionType) {
    CustomActionType["CustomAction"] = "customAction";
})(CustomActionType || (CustomActionType = {}));
export const ActionTypes = {
    ...IncomeType,
    ...ExpenseType,
    ...InvestmentTypes,
    ...CurrencySaleRevaluationType,
    ...BankReconciliationActionType,
    ...RevaluationTransactionType,
    ...FeeActionType,
    ...RealisationTypes,
    ...UnrealisedFXGainOrLossType,
    ...UnrealisedCashFXGainOrLossActionType,
    ...UnrealisedAssetFXGainOrLossType,
    ...CapitalActionTypes,
    ...PartnerTransferTypes,
    ...CustomActionType,
};
export var CreditDebitPair;
(function (CreditDebitPair) {
    CreditDebitPair["CreditDebitPair"] = "creditDebitPair";
})(CreditDebitPair || (CreditDebitPair = {}));
export const ActionTransactionSubTypes = {
    ...RealisationTransactionSubType,
    ...UnrealisedFXGainOrLossSubType,
    ...RealisedFXGainOrLossType,
    ...UnrealisedCashFXGainOrLossType,
    ...CapitalActionTransactionSubType,
    ...CreditDebitPair,
    ...UnrealisedAssetFXGainOrLossType,
    ...IncomeOrExpenseTransactionSubType,
};
//# sourceMappingURL=index.js.map